import { useLanguage } from "../contexts/LanguageContext";

export default function Accessibility() {
  const { t } = useLanguage();

  return (
    <main data-testid="accessibility-page" className="pt-28 pb-24 bg-[#0a0f1f]">
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        <h1 className="font-playfair text-4xl md:text-5xl text-[#f8f9fa] tracking-tight mb-12">
          {t("footer.accessibility")}
        </h1>

        <div className="prose-dark font-outfit text-[#94a3b8] leading-relaxed space-y-8 text-sm md:text-base">
          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">1. Compromiso con la accesibilidad</h2>
            <p>Sitayag SLU se compromete a hacer accesible su sitio web medsim.es de conformidad con las buenas prácticas de accesibilidad digital. Trabajamos continuamente para mejorar la experiencia de todos los usuarios, independientemente de sus capacidades o de la tecnología que utilicen para acceder al sitio.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">2. Estado actual de conformidad</h2>
            <p>El sitio web medsim.es se encuentra parcialmente alineado con las buenas prácticas de accesibilidad web. Trabajamos para mejorar progresivamente la accesibilidad del sitio, aunque a fecha de esta declaración no se ha realizado una auditoría formal completa de accesibilidad conforme a las Pautas de Accesibilidad para el Contenido Web (WCAG) 2.1.</p>
            <p className="mt-4">Entre las medidas adoptadas se encuentran:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Uso de HTML semántico y estructura de encabezados jerárquica.</li>
              <li>Contraste de color diseñado para facilitar la legibilidad.</li>
              <li>Navegación mediante teclado en elementos interactivos principales.</li>
              <li>Textos alternativos en imágenes.</li>
              <li>Diseño responsivo adaptable a diferentes dispositivos y tamaños de pantalla.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">3. Limitaciones conocidas</h2>
            <p>A pesar de nuestros esfuerzos, algunas áreas del sitio pueden presentar limitaciones de accesibilidad:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Algunos contenidos multimedia embebidos de terceros (vídeos de YouTube) pueden no ofrecer controles de accesibilidad completos.</li>
              <li>Determinadas animaciones pueden no ser compatibles con todas las tecnologías de asistencia.</li>
            </ul>
            <p className="mt-4">Nos comprometemos a abordar estas limitaciones a medida que sea posible.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">4. Contacto para incidencias de accesibilidad</h2>
            <p>Si encuentra alguna barrera de accesibilidad en el sitio web, o desea comunicar cualquier incidencia o sugerencia de mejora, puede contactar con nosotros a través de:</p>
            <p className="mt-4">
              <strong className="text-[#f8f9fa]">Correo electrónico:</strong>{" "}
              <a href="mailto:info@sitayag.com" className="text-[#1a6cf5] hover:underline">info@sitayag.com</a>
            </p>
            <p className="mt-2">Nos comprometemos a atender su solicitud en el menor tiempo posible y a buscar soluciones razonables.</p>
          </section>

          <p className="text-[#64748b] text-xs mt-12">Última actualización: Junio 2026</p>
        </div>
      </div>
    </main>
  );
}
